import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email_document",
  "use": "icon-email_document-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email_document\">\n<path d=\"M0 4.5V43.5H16.5V48H39V31.5H30V14.3789L20.1211 4.5H0ZM3 7.5H18V16.5H27V31.5H16.5V33V40.5H3V7.5ZM21 9.62109L24.8789 13.5H21V9.62109ZM7.5 19.5V22.5H22.5V19.5H7.5ZM7.5 25.5V28.5H22.5V25.5H7.5ZM7.5 31.5V34.5H13.5V31.5H7.5ZM21.4541 34.5H34.0459L27.75 38.6982L21.4541 34.5ZM19.5 36.8027L27.75 42.3018L36 36.8027V45H19.5V36.8027Z\" fill=\"#0284C7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol